import React from 'react';

const unavailibleFormFallback = (message) => (
  <>
  <h1>Nothing to show</h1>
  <p>{(message !== undefined) && message}</p>
  </>
)

export default unavailibleFormFallback;
